/**
 * Removes dashes from a string.
 *
 * @param {string} str - The input string.
 * @returns {string} The modified string with dashes removed.
 */
const removeDash = (str) => {
  if (str.includes('-')) {
    return str.replace(/-/g, '');
  }
  return str;
};

export default removeDash;
